module.exports = __webpack_public_path__ + "static/sketchapp2-84d8835604e8bb35edd1e4d9badff816.png";